/*
 * Copyright (c) 2020. Sonrai Analytics Ltd.
 * Developed by Warren Dowey
 */

import { Injectable } from '@angular/core';
import { ApiBaseService } from '@app/services/api-services/api-base.service';
import { HttpClient } from '@angular/common/http';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
import { ComponentPermissionsModel } from '@app/models/component-permissions.model';

@Injectable({
  providedIn: 'root',
})
export class ComponentPermissionsListService extends ApiBaseService {
  private _componentPermissionsList: ComponentPermissionsModel[] = [];
  protected _endpoint = 'component_permissions';

  constructor(http: HttpClient, authUserService: AuthUserService) {
    super(http, authUserService);
  }

  get componentPermissionsList(): ComponentPermissionsModel[] {
    return this._componentPermissionsList;
  }

  set componentPermissionsList(value: ComponentPermissionsModel[]) {
    this._componentPermissionsList = value;
  }
  /**
   *   Warren Dowey
   *
   *  addToList
   *
   * : handles the insert of a new ComponentPermissionsModel into the list
   *
   * @param data of type ComponentPermissionsModel
   */
  addToList(data: ComponentPermissionsModel): void {
    this.componentPermissionsList.push(data);
  }

  /**
   *  Warren Dowey
   *
   *  handleData
   *
   * : handles the data from the list by extending the handleData function from the API base service
   *
   * @param data of type ComponentPermissionsModel[]
   *
   * @returns Void: get the components from the postgres database and create the list
   */
  protected handleData(data: ComponentPermissionsModel[]): void {
    let permission: ComponentPermissionsModel;
    this.componentPermissionsList = [];
    this.fetchTimestamp = new Date();
    for (const item of data) {
      permission = new ComponentPermissionsModel();
      this.addToList(permission.fromJson(item));
    }
    super.handleData(this.componentPermissionsList);
  }
}
